import React, { useEffect, useContext } from 'react';
import './styles/app.scss';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';

import { getMaintenanceDetails } from './api/maintenance';
import { SecurityProvider, PrivateRoute, ITRoute } from './components/Security/security';
import { StoreContext } from './components/Store';
import { SSOProvider } from './components/SSO/SSO';

import Layout from './layout/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Authentication/Login';

import MaintenancePage from './pages/MaintenancePage';
import ErrorSnackbar from './components/Errors/ErrorSnackbar';

import RegistrationContainer from './pages/Registration/RegistrationContainer';

import PasswordResetByUser from './pages/Authentication/PasswordResetByUser';
import ConfirmResetFromEmail from './pages/Authentication/ConfirmResetFromEmail';

import SelectCompanyForENS from './pages/Decs/Screens/0. Select Company';
import GBENSContainer from './pages/Decs/GBENSContainer';

import Dashboard from './pages/Dashboard/Dashboard/Dashboard';
import ShipmentView from './pages/Dashboard/ShipmentView/ShipmentView';
import PrintablePage from './pages/Dashboard/PrintablePage';

import CustomerSettings from './pages/Settings/CustomerSettings';
import SelectCustomer from './pages/Settings/SelectCustomer';
import ReportingContainer from './pages/Reporting/ReportingContainer';
import MaintenanceBannerAdmin from './pages/Admin/MaintenanceBannerAdmin';
import EoriNumberValidation from './pages/Admin/EoriNumberValidation';

function App() {
  const store = useContext(StoreContext);

  useEffect(() => {
    const fetch = async () => {
      const data = await getMaintenanceDetails();
      store.maintenancePage[1](parseInt(data?.siteMaintenance) === 1 ? data.maintenanceMessage : '');
      store.maintenanceBanner[1](parseInt(data?.showBanner) === 1 ? data.bannerMessage : '');
    };
    fetch();

    const env = process.env.REACT_APP_ENV || 'prod';
    const robotsMeta = document.getElementById('robotsMeta');
    if (['dev', 'test'].includes(env)) {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'noindex');
      } else {
        const noIndex = document.createElement('meta');
        noIndex.setAttribute('id', 'robotsMeta');
        noIndex.setAttribute('name', 'robots');
        noIndex.setAttribute('content', 'noindex');
        document.head.appendChild(noIndex);
      }
    } else if (robotsMeta) {
      robotsMeta.remove();
    }
  }, []);

  useEffect(() => {
    LicenseInfo.setLicenseKey(
      '14364f1922c59a71b819de9105bfb4dfTz0xMjQ0NDgsRT0xODAwMjMwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
    );
  });

  return (
    <div className="App">
      <ErrorSnackbar
        message={store.errorSnackbarMessage[0]}
        isOpen={store.showErrorSnackbar[0]}
        onClose={() => store.hideError()}
      />
      <Router>
        <SecurityProvider>
          <SSOProvider>
            <Routes>
              {store.maintenancePage[0] !== '' ? (
                <Route
                  exact
                  path="*"
                  element={<MaintenancePage maintenanceMessage={store.maintenancePage[0]} auth={false} />}
                  auth={false}
                />
              ) : (
                <Route element={<Layout />}>
                  <Route exact path="/" element={<LandingPage auth={false} />} />
                  <Route exact path="/login" element={<Login />} auth={false} />
                  <Route exact path="/confirmreset/:token" element={<ConfirmResetFromEmail />} auth={false} />
                  <Route exact path="/PasswordReset" element={<PasswordResetByUser />} auth={false} />
                  <Route exact path="/register" element={<RegistrationContainer />} auth={false} />
                  <Route exact path="/" element={<PrivateRoute />}>
                    <Route
                      exact
                      path="/EnsDeclarationSelectCompany"
                      element={
                        <div className="full-page-wrapper">
                          <SelectCompanyForENS />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/EnsDeclaration"
                      element={
                        <div className="full-page-wrapper">
                          <GBENSContainer />
                        </div>
                      }
                      auth={false}
                    />

                    <Route
                      exact
                      path="/Dashboard"
                      element={
                        <div className="full-page-wrapper">
                          <Dashboard />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/ShipmentView"
                      element={
                        <div className="full-page-wrapper">
                          <ShipmentView />
                        </div>
                      }
                      auth={false}
                    />
                    <Route exact path="/printShipment" element={<PrintablePage />} auth={false} />

                    <Route
                      exact
                      path="/SelectCustomer"
                      element={
                        <div className="full-page-wrapper">
                          <SelectCustomer />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/CustomerSettings"
                      element={
                        <div className="full-page-wrapper">
                          <CustomerSettings />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/Reporting"
                      element={
                        <div className="full-page-wrapper">
                          <ReportingContainer />
                        </div>
                      }
                      auth={false}
                    />
                    <Route element={<ITRoute />}>
                      <Route
                        exact
                        path="/Admin/MaintenanceBanner"
                        element={
                          <div className="full-page-wrapper">
                            <MaintenanceBannerAdmin />
                          </div>
                        }
                        auth={false}
                      />
                      <Route
                        exact
                        path="/Admin/EoriNumberValidation"
                        element={
                          <div className="full-page-wrapper">
                            <EoriNumberValidation />
                          </div>
                        }
                        auth={false}
                      />
                    </Route>
                  </Route>
                  Dashboard
                </Route>
              )}
            </Routes>
          </SSOProvider>
        </SecurityProvider>
      </Router>
    </div>
  );
}

export default App;
